import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "media-view"
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_video_player = _resolveComponent("video-player")!

  return (_ctx.preparedMedia)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.loaded)
          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
              key: 0,
              indeterminate: "",
              class: "media-view__loader",
              color: "white"
            }))
          : _createCommentVNode("", true),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.preparedMedia.type === 'image')
              ? _withDirectives((_openBlock(), _createElementBlock("img", {
                  key: 0,
                  ref: "parallaxEl",
                  src: _ctx.preparedMedia.url,
                  alt: "",
                  style: _normalizeStyle(_ctx.style),
                  onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLoaded && _ctx.onLoaded(...args)))
                }, null, 44, _hoisted_2)), [
                  [_vShow, _ctx.loaded]
                ])
              : (_openBlock(), _createBlock(_component_video_player, {
                  key: 1,
                  ref: "parallaxEl",
                  options: _ctx.generateVideoOptions(),
                  active: _ctx.active,
                  style: _normalizeStyle(_ctx.style)
                }, null, 8, ["options", "active", "style"]))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}